import { platformIdentity } from '@shared/platform';

/**
 * Tier 3: Blueprint Interface
 * 
 * This file is a mandatory part of the CadOps Platform Blueprint.
 * It provides a consistent interface for the application to access 
 * the Sovereign Identity managed in the Shared Core.
 */
export const platform = platformIdentity;
